import './new-birthday-reward.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormBirthdayReward from "../form-birthday-reward/form-birthday-reward";
import { useNewBirthdayReward } from './new-birthday-reward.hook';

export function NewBirthdayReward() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewBirthdayReward();

  return (
    <div id="NewBirthdayReward" className="birthday-reward">
      <HeaderContent
        title={<h1>New Birthday Reward</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormBirthdayReward />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewBirthdayReward;